var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DynamicLayout } from './dynamic-layout';
import { forIn, isNil, values } from 'lodash';
var DynamicFormLayout = /** @class */ (function (_super) {
    __extends(DynamicFormLayout, _super);
    function DynamicFormLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DynamicFormLayout.prototype.countNumberOfControls = function () {
        return (this.countGridControls(this.getMetaForm().layoutModel.content) +
            this.countGridControls(this.getMetaForm().layoutModel.footer) +
            (this.getMetaForm().layoutModel.header ? 1 : 0) +
            (this.getMetaForm().layoutModel.subwayMap && this.hasSubwayViewPermission ? 1 : 0));
    };
    DynamicFormLayout.prototype.isControllerRequiredToSet = function (controller) {
        if (!isNil(controller.fields)) {
            var fieldValues_1 = values(controller.fields);
            if (fieldValues_1.length === 1 &&
                !isNil(fieldValues_1[0]) &&
                !isNil(fieldValues_1[0].metaFieldId)) {
                return !isNil(this.getMetaForm().requiredMetaFieldIds.find(function (metaFieldId) {
                    return metaFieldId.getSystemName() ===
                        fieldValues_1[0].metaFieldId.systemName;
                }));
            }
        }
        return false;
    };
    DynamicFormLayout.prototype.countGridControls = function (grid) {
        var sum = 0;
        if (grid) {
            for (var _i = 0, _a = grid.rows; _i < _a.length; _i++) {
                var row = _a[_i];
                for (var _b = 0, _c = row.cells; _b < _c.length; _b++) {
                    var cell = _c[_b];
                    if (cell.controlModel) {
                        var controlFieldsNames = this.getControlFieldsNames(cell.controlModel);
                        if (this.isUserHasViewControlPermission(controlFieldsNames) &&
                            !cell.controlModel.hasDeletedField) {
                            sum++;
                        }
                    }
                    else if (cell.grid) {
                        sum += this.countGridControls(cell.grid);
                    }
                }
            }
        }
        return sum;
    };
    DynamicFormLayout.prototype.getControlFieldsNames = function (controlModel) {
        var result = new Set();
        if (controlModel.fields) {
            forIn(controlModel.fields, function (value) {
                if (!isNil(value) &&
                    !isNil(value.metaFieldId) &&
                    !isNil(value.metaFieldId.systemName)) {
                    result.add(value.metaFieldId.systemName);
                }
            });
        }
        return result;
    };
    DynamicFormLayout.prototype.isUserHasViewControlPermission = function (controlFieldsNames) {
        if (!this.getMetaForm().dePermission) {
            return true;
        }
        return this.getEntity() && this.getEntity().getInstanceId() === null
            ? this.getMetaForm().dePermission.addableFields.filter(function (addableFieldName) { return controlFieldsNames.has(addableFieldName); }).length === controlFieldsNames.size
            : this.getMetaForm().dePermission.viewableFields.filter(function (viewableFieldName) { return controlFieldsNames.has(viewableFieldName); }).length === controlFieldsNames.size;
    };
    return DynamicFormLayout;
}(DynamicLayout));
export { DynamicFormLayout };
//# sourceMappingURL=dynamic-form-layout.js.map